import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatTableModule } from '@angular/material/table';
import { SharedModule } from 'src/app/components/shared/shared.module';
import { SharedReportsModule } from '../../shared/shared-reports.module';
import { GroupErrorReportComponent } from './group-error-report/group-error-report.component';
import { LocationErrorReportComponent } from './location-error-report/location-error-report.component';

@NgModule({
  declarations: [GroupErrorReportComponent, LocationErrorReportComponent],
  imports: [
    CommonModule,
    FormsModule,
    SharedModule,
    ReactiveFormsModule,
    SharedReportsModule,
    MatTableModule,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ErrorReportsModule {}
